import { DataTable } from '../../../components/dataTable';
import { Button } from '../../../components/button';
import { ButtonType } from '../../../common/enum/buttonType';

import { ViewProps } from './model';
import { SourceModal } from './sourceModal';

import './style.scss';

export const View = (props: ViewProps) => {
    const { columns, data, keyField, openNewResourceModal, isSourceModalOpen } = props;
    return (
        <div className="internet-resource">
            {isSourceModalOpen && <SourceModal />}
            <Button
                className="add-resource-button"
                title="Add a new internet resource"
                type={ButtonType.primary}
                onClick={openNewResourceModal}
            />
            <DataTable className="internet-resource-table" columns={columns} data={data} keyField={keyField} />
        </div>
    );
};
